//============================
//# hmbokrephead
//============================

export default interface CashFlowRiportHead {
  id: number;
  name: string;
  year: number;
  yearName: string;
  remark: string;
  reportHead: number;
  reportHeadName: string;
  cashOpenAmount: number;
  planProfitAmount: number;
  isOpenOverride: boolean;
}

export const CashFlowRiportHeadDefaultProps: CashFlowRiportHead = {
  id: 0,
  name: "-",
  year: 0,
  yearName: "-",
  remark: "-",
  reportHead: 0,
  reportHeadName: "-",
  cashOpenAmount: 0,
  planProfitAmount: 0,
  isOpenOverride: false,
}